var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEqualGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 228,
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "akar-icons:equal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M152 133H76M152 95H76",
    stroke: "#545454",
    strokeWidth: 19,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M114 209C166.467 209 209 166.467 209 114C209 61.5329 166.467 19 114 19C61.5329 19 19 61.5329 19 114C19 166.467 61.5329 209 114 209Z",
    stroke: "#545454",
    strokeWidth: 19
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqualGrey);
export default __webpack_public_path__ + "static/media/equalGrey.aade808e9296c62e2aa1f15d2acb521f.svg";
export { ForwardRef as ReactComponent };